
import { Component, OnInit } from '@angular/core';
import { MainService } from '../../../pet/pet-layout/service/main.service';
import { ProfileService } from '../../../pet/pet-layout/service/profile.service';
import { Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { NgxSpinnerService } from "ngx-spinner";
import { AuthenticationService } from '../../../../app/authentication.service'
import { session } from '../../../../environments/environment.session'
@Component({
  selector: '[app-noc-sidebar]',
  templateUrl: './noc-sidebar.component.html',
  styleUrls: ['./noc-sidebar.component.css']
})
export class NocSidebarComponent implements OnInit {

  carto_flag: boolean = false
  user_id: any;
  imgURL: any;
  erpUser: any;
  ctp_flag: any = false;
  acct_flag: any = false
  role: any;
  clerk_flag: any = false;
  accInfo: any;
  deprtmt: any = false
  assigned_compoment = []
  sidebar = new Object()
  //allLableShowObjHR={}
  userInfo = { emp_name: 'Ram Prasad', designation: 'Accountant' }
  constructor(public auth: AuthenticationService, private router: Router, private spinner: NgxSpinnerService, private profileService: ProfileService, private sanitizer: DomSanitizer, public mainService: MainService) {
    this.erpUser = JSON.parse(atob(session.erpUser));
    this.user_id = this.erpUser.user_id;
    this.assigned_compoment = this.erpUser.assigned_component;
    for (let i = 0; i < this.erpUser.role_cd.length; i++) {
      if (this.erpUser.role_cd[i] == 'CRK') {
        this.role = this.erpUser.role_cd[i]
        this.clerk_flag = true
        this.ctp_flag = false
        this.acct_flag = false
        this.deprtmt = false

      } else if (this.erpUser.role_cd[i] == 'CTP') {
        this.role = this.erpUser.role_cd[i]
        this.clerk_flag = false
        this.ctp_flag = true
        this.acct_flag = false
        this.deprtmt = true

      }
      else if (this.erpUser.role_cd[i] == "ACCOUNTANT") {
        this.role = this.erpUser.role_cd[i]
        this.clerk_flag = false
        this.ctp_flag = false
        this.acct_flag = true
        this.deprtmt = false

      } else if (this.erpUser.role_cd[i] == "AMC") {
        this.role = this.erpUser.role_cd[i]
        this.clerk_flag = false
        this.ctp_flag = true
        this.acct_flag = false
        this.deprtmt = true

      }
      // else if (this.erpUser.role_cd[i] == "CARTOGRAPHER") {
      //   this.role = this.erpUser.role_cd[i]
      //   this.clerk_flag = false
      //   this.ctp_flag = false
      //   this.acct_flag = false
      //   this.deprtmt=false
      //   this.carto_flag = true
      // }
      else if (this.erpUser.role_cd[i] == 'DRFT_MAN' || this.erpUser.role_cd[i] == "CHEIF ENG" || this.erpUser.role_cd[i] == "AMC") {

        this.role = this.erpUser.role_cd[i]
        this.clerk_flag = false
        this.ctp_flag = false
        this.acct_flag = false
        this.deprtmt = true





      }

    }

    // this.sidebar['dashbord'] = !this.assigned_compoment.includes('EMD-R1')
    // this.sidebar['administration'] = !this.assigned_compoment.includes('EMD-R2')
    // this.sidebar['master_data'] = !this.assigned_compoment.includes('EMD-R3')
    // this.sidebar['security'] = !this.assigned_compoment.includes('EMD-R4')
    // this.sidebar['role'] = !this.assigned_compoment.includes('EMD-R5')
    // this.sidebar['user'] = !this.assigned_compoment.includes('EMD-R6')
    // this.sidebar['code_value'] = !this.assigned_compoment.includes('EMD-R10')
    // this.sidebar['hierarchy'] = !this.assigned_compoment.includes('EMD-R11')
    // this.sidebar['tender_management'] = !this.assigned_compoment.includes('EMD-R12')
    // this.sidebar['vendor_management'] = !this.assigned_compoment.includes('EMD-R13')
    // this.sidebar['payment_management'] = !this.assigned_compoment.includes('EMD-R14')
    // this.sidebar['assign_tender'] = !this.assigned_compoment.includes('EMD-R15')
    // this.sidebar['emd_refund'] = !this.assigned_compoment.includes('EMD-R16')
    // this.sidebar['data_assignment'] = !this.assigned_compoment.includes('EMD-R7')
    // this.sidebar['work_flow'] = !this.assigned_compoment.includes('EMD-R8')
    // this.sidebar['field'] = !this.assigned_compoment.includes('EMD-R9')

  }
  hidden = true;
  async ngOnInit() {
    // this.erpUser=JSON.parse(atob(session.erpUser)) ;

    this.user_id = this.erpUser.user_id;
    if (this.erpUser.is_admin == 0) {
      this.hidden = true;
    } else {
      this.hidden = false
    }
    this.imgURL = './assets/img/admin-avatar.png';
    await this.getUserImage();
    // await this.getUserInfo();
    await this.getAccImage();
    // await this.getAccInfo();
  }

  home() {
    this.router.navigate(['/index'])
  }
  refreshCol() {
    var col = document.getElementsByClassName('collapse')

    for (let i = 0; i <= col.length; i++) {
      if (col[i].classList.contains('show')) {
        col[i].classList.remove('show');
      }
    }

  }





  async getUserImage() {
    const res = await this.profileService.getImage(this.user_id);
    if (res) {
      const unsafeImageUrl = window.URL.createObjectURL(res); // URL.createObjectURL(res);
      this.imgURL = this.sanitizer.bypassSecurityTrustUrl(unsafeImageUrl);
      this.mainService.profileImageUrl = this.imgURL;

    }
  }
  async getUserInfo() {
    this.spinner.show()
    var resp = await this.profileService.getUserProfileInfo(this.user_id);
    if (resp['error'] == false) {
      this.spinner.hide()

      this.userInfo = resp.data[0];
    } else {

      this.spinner.hide()
    }
  }
  async getAccImage() {
    const res = await this.profileService.getAccImage(this.erpUser.b_acct_id);
    if (res) {
      const unsafeImageUrl = window.URL.createObjectURL(res); // URL.createObjectURL(res);
      this.imgURL = this.sanitizer.bypassSecurityTrustUrl(unsafeImageUrl);
      this.mainService.accountImageUrl = this.imgURL;

    }
  }
  async getAccInfo() {
    this.spinner.show()
    var resp = await this.profileService.getAccProfileInfo(this.erpUser.b_acct_id);
    if (resp['error'] == false) {
      this.spinner.hide()
      this.accInfo = resp.data[0];
      this.mainService.accInfo = this.accInfo;
    } else {
      this.spinner.hide()

    }

  }


}
